import { render, staticRenderFns } from "./Roma.vue?vue&type=template&id=89d0f5ce&scoped=true&"
import script from "./Roma.vue?vue&type=script&lang=js&"
export * from "./Roma.vue?vue&type=script&lang=js&"
import style0 from "./Roma.vue?vue&type=style&index=0&id=89d0f5ce&lang=scss&scoped=true&"
import style1 from "./Roma.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d0f5ce",
  null
  
)

export default component.exports